module.exports = __webpack_public_path__ + "media/images/missing-category-inactive-2288100e7d26045ed4dc286e77efb3c8.png";